import $ from 'jquery';
import 'webpack-jquery-ui';
import 'jquery-ui-touch-punch';
import 'jquery-serializeobject';
import './global.js';

const openPopup = (popup) => {
    popup.classList.add('active');
    // document.body.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
};
const closePopup = (popup) => {
    popup.classList.remove('active');
    // document.body.style.overflow = 'auto';
    document.body.classList.remove('overflow-hidden');
};

const creditsSlider = $('.creditsWithoutDeposit-slider');
const creditsWdMain = document.querySelectorAll('.creditsWithoutDeposit-main')[0];
const creditsWdInput = document.querySelectorAll('.creditsWithoutDeposit-input')[0];
const creditsWdSum = document.querySelectorAll('.js-crecreditsWithoutDeposit-sum')[0];
const creditsWdTotal = document.querySelectorAll('.js-crecreditsWithoutDeposit-to-pay')[0];
const creditsWdCommission = document.querySelectorAll('.js-crecreditsWithoutDeposit-use')[0];
const creditsWdDate = document.querySelectorAll('.js-crecreditsWithoutDeposit-date')[0];
const creditsWdSubmitFirst = document.querySelectorAll('.creditsWithoutDeposit-submit-button .btn')[0];
const creditsWdForm = document.querySelectorAll('.creditsWithoutDeposit-form')[0];
const changeBtn = document.querySelectorAll('.creditsWithoutDeposit-form-row-res-change .change-btn')[0];
const creditsWdFormSum = document.querySelectorAll('.creditsWithoutDeposit-form-row-res-sum span')[0];
const creditsWdFormTerm = document.querySelectorAll('.creditsWithoutDeposit-form-row-res-term span')[0];
const creditsWdVerification = document.querySelectorAll('.creditsWithoutDeposit-verification')[0];
const creditsWdFormSubmitButton = document.querySelectorAll('.creditsWithoutDeposit-form-submit-button .btn')[0];
const creditsWdVerificationButton = document.querySelectorAll('.creditsWithoutDeposit-verification-submit-button .btn')[0];
const verificationInput = document.querySelectorAll('#verification-number')[0];
const creditsWdSuccess = document.querySelectorAll('.creditsWithoutDeposit-success')[0];
const creditsHelpBlock = document.querySelectorAll('.creditsWithoutDeposit-result .help-block')[0];
const creditsRulesLink = document.querySelectorAll('.creditsWithoutDeposit-rules-link')[0];
const creditsPopup = document.querySelectorAll('#rules')[0];
const credistPopupClose = document.querySelectorAll('#rules .popup-close')[0];
const creditsCheckBox = document.querySelectorAll('#no-deposit-checkbox')[0];
const creditTermInput = document.querySelectorAll('#no-deposit-term')[0];
const creditSumInput = document.querySelectorAll('#no-deposit-sum')[0];
const creditsWDFormElems = Array.from(document.querySelectorAll('#no-deposit-form')[0].elements);
const name = document.querySelectorAll('#creditapplicationform-first_name')[0];
const fatherName = document.querySelectorAll('#creditapplicationform-middle_name')[0];
const surName = document.querySelectorAll('#creditapplicationform-last_name')[0];
const mail = document.querySelectorAll('#creditapplicationform-email')[0];
const inn = document.querySelectorAll('#creditapplicationform-inn')[0];
const tel = document.querySelectorAll('#tel')[0];
const birthday = document.querySelectorAll('#creditapplicationform-birthday')[0];
const sex = document.querySelectorAll('#creditapplicationform-sex')[0];

const FINME_CREATE = "https://api.finme.ua/v2/application/create?access-token=6iaLB6MBl9Jm5CJ0JMcSl-m0-O2SY1Rv";
const FINME_CONFIRM = "https://api.finme.ua/v2/approve-sms/confirm?access-token=6iaLB6MBl9Jm5CJ0JMcSl-m0-O2SY1Rv";


var sliderValue;
var sliderMinValue;
var sliderMAXValue;
var days = [];
var sum = [];
var init_day;
var commission = [];
var init_value = [];
var creditsWdTerm;
var currentTerm;
var translation;

$(document).ready(function(){
  var amountAndTermForm = $('.creditsWithoutDeposit-main'),
      shortForm = $('.creditsWithoutDeposit-form');

    if(!amountAndTermForm.hasClass('creditsWithoutDeposit-closed') && !shortForm.hasClass('creditsWithoutDeposit-opened')) {
      addGTMLayer('Amount_and_Term');
    }
});

// $(document).on('click', '#sumconfirm', function () {
//     addGTMLayer('Short_Form');
// });

const addGTMLayer = (name) => {
  if (window.dataLayer) {
      window.dataLayer.push({ event: name })
  }
}

const data = new Date();
const dataDays = (date) => {
    let dd = date.getDate();
    if (dd < 10) dd = '0' + dd;

    let mm = date.getMonth() + 1;
    if (mm < 10) mm = '0' + mm;

    let yy = date.getFullYear();
    if (yy < 10) yy = '0' + yy;
    return dd + '.' + mm + '.' + yy;
}

const addDays = (date, days) => {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

const setData = () => {
    creditsWdDate.textContent = dataDays(data);
    creditsWdTerm.forEach((item) => {
        if (!item.classList.contains('checked-term')) {
            creditsWdSubmitFirst.setAttribute('disabled', 'enabled');
        }
        item.addEventListener('click', (e) => {
            e.preventDefault();
            creditsWdTerm.forEach((links) => {
                links.classList.remove('checked-term');
            })
            item.classList.add('checked-term');
            setSlider($.inArray(Number(item.getAttribute('data-days')), days));
            if (item.classList.contains('checked-term')) {

                creditsWdSubmitFirst.removeAttribute('disabled', 'enabled');
                let checkedTerm = document.querySelectorAll('.checked-term')[0];
                let dataDaysAttribute = checkedTerm.getAttribute('data-days');
                currentTerm = checkedTerm.getAttribute('data-days');
                creditsWdDate.textContent = dataDays(addDays(new Date(), parseInt(dataDaysAttribute)));
                creditsWdFormTerm.textContent = " " + checkedTerm.textContent;
                creditTermInput.value = parseInt(checkedTerm.textContent);
            }
        })
    })
}

function updateClient(type) {
    let segment = JSI18N.activeLanguage.is_default ? '' : ('/' + JSI18N.activeLanguage.code);

    $.getJSON(segment + "/api/products/" + type, function (data) {
        var items = data;

        $(".creditsWithoutDeposit-term-items").html('');
        days = [];
        commission = [];
        sum = [];
        init_value = [];

        if (items) {
            $.each(items['in'], function (key, value) {
                if (value['period']['to'] > 5) {
                    translation = JSI18N.t('frontend.credit-application', 'days');
                } else {
                    translation = JSI18N.t('frontend.credit-application', 'day');
                }
                if ($.inArray(Number(value['period']['to']), days) < 0)
                {
                    $(".creditsWithoutDeposit-term-items").append('<div class="creditsWithoutDeposit-term-item"><a class="btn" href="" data-days="' + Number(value['period']['to']) + '">' + Number(value['period']['to']) + ' ' + translation + '</a></div>');
                    days.push(Number(value['period']['to']));
                    sum[$.inArray(Number(value['period']['to']), days)] = [];
                    commission[$.inArray(Number(value['period']['to']), days)] = [];
                }
                sum[$.inArray(Number(value['period']['to']), days)].push(value['sum']);
                commission[$.inArray(Number(value['period']['to']), days)].push( Number(items['results'][key]['commission']));
            });

            $.each(items['results'], function (key, value) {
                init_value.push(Number(value['init_value']));
                init_day = Number(value['init_day']);
            })
        }
        if ($('#period').val() !== '' && $('#period').length !== 0)
        {
            if ($.inArray(Number($('#period').val()), days) > -1)
            {
                init_day = Number($('#period').val());
            }
            $('#period').val('');
        }
        if (typeof currentTerm !== 'undefined') {
            if ($.inArray(Number(currentTerm), days) > -1) {
                init_day = Number(currentTerm);
            }
        }
        creditsWdTerm = document.querySelectorAll('.creditsWithoutDeposit-term-item .btn');
        setSlider($.inArray(init_day, days));
        setData();
        currentTerm = init_day;
        creditsWdTerm.forEach((item) => {
            if (item.getAttribute('data-days') == init_day) {
                item.classList.add('checked-term');
                creditsWdSubmitFirst.removeAttribute('disabled', 'enabled');
                let checkedTerm = item;
                let dataDaysAttribute = checkedTerm.getAttribute('data-days');
                creditsWdDate.textContent = dataDays(addDays(new Date(), parseInt(dataDaysAttribute)));
                creditsWdFormTerm.textContent = " " + checkedTerm.textContent;
                creditTermInput.value = parseInt(checkedTerm.textContent);
            }
        });

    });
}

const setSlider = (index) => {
    let fromSliderCalc = false;
    sliderMAXValue = Number(sum[index][0]['to']);
    sliderMinValue = Number(sum[index][0]['from']);
    $.each(sum[index], function (key, value) {
        if (value['to'] > sliderMAXValue) {
            sliderMAXValue = value['to'];
        }
        if (value['from'] < sliderMinValue) {
            sliderMinValue = value['from'];
        }
    });
    if (!sliderValue) {
        sliderValue = init_value[index];
    } else if (creditsWdInput.value < sliderMinValue) {
        sliderValue = sliderMinValue;
    } else if (creditsWdInput.value > sliderMAXValue) {
        sliderValue = sliderMAXValue;
    } else {
        sliderValue = creditsWdInput.value;
    }
    if ($('#sum').val() !== '' && $('#sum').length !== 0)
    {
        if ($('#sum').val() >= sliderMinValue && $('#sum').val() <= sliderMAXValue)
        {
            sliderValue = $('#sum').val();
            fromSliderCalc = true;
        }
        $('#sum').val('');
    }
    creditsWdSum.textContent = sliderValue + " " + " грн";

    let commission = sliderValue * getCommision(index, Number(sliderValue)) * days[index];
    commission = Math.ceil(commission * 100) / 100;
    commission = +commission.toFixed(2);

    creditsWdCommission.textContent = commission + " грн";
    creditsWdTotal.textContent = (Number(sliderValue) + commission) + " грн";

    creditSumInput.value = sliderValue;
    creditsWdInput.value = sliderValue;
    creditsWdInput.value = sliderValue;
    creditsSlider.slider({
        range: 'min',
        step: 100,
        value: sliderValue,
        min: sliderMinValue,
        max: sliderMAXValue,
        slide: function (event, ui) {
            creditsWdInput.value = ui.value;
            creditSumInput.value = ui.value;
            let creditsWdInputValue = creditsWdInput.value;
            let commission = ui.value * getCommision(index, Number(ui.value)) * days[index];
            commission = Math.ceil(commission * 100) / 100;
            commission = commission.toFixed(2);

          creditsWdCommission.textContent = commission + " грн";
            creditsWdTotal.textContent = (Number(ui.value) + +commission).toFixed(2) + " грн";

            creditsWdSum.textContent = creditsWdInputValue + " " + "грн";
            if (creditsWdInputValue <= sliderMAXValue) {
                creditsHelpBlock.style.display = "none";
                creditsHelpBlock.parentNode.classList.remove('has-error');
            }
        }
    });
    creditsWdInput.addEventListener('input', sliderMaxValue);
    if (fromSliderCalc) {
        // $('#sumconfirm').click();
    }
};

function getCommision(index, currentValue) {
    let result = 1;
    $.each(sum[index], function (key, value) {
        if (currentValue <= value['to'] && currentValue >= value['from']) {
            result =  Number(commission[index][key]);
        }
    });
   return result;
}

const sliderMaxValue = () => {
    creditsSlider.slider("value", creditsWdInput.value);
    let creditsWdInputValue = creditsWdInput.value;
    creditsWdSum.textContent = creditsWdInputValue + " " + "грн";
    let index = $.inArray(Number(currentTerm), days);
    let commission = Math.round(creditsWdInput.value * getCommision(index, Number(creditsWdInput.value)) * days[index]);
    creditsWdCommission.textContent = commission + " грн";
    creditsWdTotal.textContent = (Number(creditsWdInput.value) + commission) + " грн";
    let checkedTerm = document.querySelectorAll('.checked-term')[0];
    if (creditsWdInput.value > sliderMAXValue) {
        creditsHelpBlock.style.display = "block";
        creditsHelpBlock.parentNode.classList.add('has-error');
        creditsWdSubmitFirst.setAttribute('disabled', 'enabled');
    }
    else if (checkedTerm) {
        creditsWdSubmitFirst.removeAttribute('disabled', 'enabled');
        creditsHelpBlock.style.display = "none";
    }
    else {
        creditsHelpBlock.style.display = "none";
        creditsHelpBlock.parentNode.classList.remove('has-error');
    }
    creditSumInput.value = creditsWdInput.value;
}

// Allow only numbers in input.
$(".creditsWithoutDeposit-input").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
});

const validationCreditsForm = () => {
    creditsWDFormElems.forEach((item) => {
        item.addEventListener('input', () => {
            if (item.value != 0) {
                item.parentNode.classList.remove('has-error');
            }
        })
    })
    name.addEventListener('change', () => {
        validName(name);
    })
    name.addEventListener('blur', () => {
        validName(name);
    })
    fatherName.addEventListener('change', () => {
        validName(fatherName);
    })
    fatherName.addEventListener('blur', () => {
        validName(fatherName);
    })
    surName.addEventListener('change', () => {
        validName(surName);
    })
    creditsCheckBox.addEventListener('change', () => {
        validCheckbox();
    })
    creditsCheckBox.addEventListener('blur', () => {
        validCheckbox();
    })
    surName.addEventListener('blur', () => {
        validName(surName);
    })
    mail.addEventListener('change', () => {
        validMail(mail);
    })
    mail.addEventListener('blur', () => {
        validMail(mail);
    })
    inn.addEventListener('change', () => {
        validDateOfBirth(inn.value, inn);
        validBirthDaySameWithInn();
        validSexSameWithInn();
    })
    inn.addEventListener('blur', () => {
        validDateOfBirth(inn.value, inn);
        validBirthDaySameWithInn();
        validSexSameWithInn();
    })

    birthday.addEventListener('change', () => {
        validBirthDaySameWithInn();
    })
    birthday.addEventListener('blur', () => {
        validBirthDaySameWithInn();
    })


    sex.addEventListener('change', () => {
        validSexSameWithInn();
    })

    sex.addEventListener('blur', () => {
        validSexSameWithInn();
    })

    tel.addEventListener('change', () => {
        validTelNumber(tel);
    })
    tel.addEventListener('blur', () => {
        validTelNumber(tel);
    })
}

creditsWdInput.addEventListener('blur', () => {
    validateSum();
})

const validName = (value) => {
    const patt = /[а-яА-Я]+/g;
    const pattNumber = /[^0-9]/g;
    if (patt.test(value.value) === false || value.value == '') {
        value.parentNode.classList.add('has-error');
        value.parentNode.classList.remove('has-success');
        value.nextElementSibling.textContent = "Некорректное значение" + " " + "'" + value.parentNode.childNodes[1].textContent + "'";
        return false;
    }
    else {
        value.parentNode.classList.remove('has-error');
        value.parentNode.classList.add('has-success');
        return true;
    }
}

function validateSum() {
    let value = $('.creditsWithoutDeposit-input').val();
    if (value > sliderMAXValue || value < sliderMinValue || value === '')
    {
        creditsWdInput.parentNode.classList.add('has-error');
        creditsWdInput.parentNode.classList.remove('has-success');
        return false;
    } else {
        creditsWdInput.parentNode.classList.remove('has-error');
        creditsWdInput.parentNode.classList.add('has-success');
        return true;
    }
}

const validCheckbox = () => {
    if (creditsCheckBox.checked) {
        creditsCheckBox.parentNode.classList.remove('has-error');
        creditsCheckBox.parentNode.classList.add('has-success');
        return true;
    } else {
        creditsCheckBox.parentNode.classList.add('has-error');
        creditsCheckBox.parentNode.classList.remove('has-success');
        return false;
    }
};

const validMail = (value) => {
    const patt = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (patt.test(value.value) === false && value.value != '') {
        value.parentNode.classList.add('has-error');
        value.parentNode.classList.remove('has-success');
        value.nextElementSibling.textContent = "Некорректное значение" + " " + "'" + value.parentNode.childNodes[1].textContent + "'";
        return false;
    }
    else {
        value.parentNode.classList.remove('has-error');
        value.parentNode.classList.add('has-success');
        return true;
    }
};

const validDateOfBirth = (value, input) => {
    if (value.length >= 0) {
        let dateOfBirth = new Date('1900', '00', '00');
        let currentDate = new Date();
        dateOfBirth.setDate(dateOfBirth.getDate() + parseInt(value.slice(0, -5)));
        let years = currentDate.getFullYear() - dateOfBirth.getFullYear();
        if (years >= 21 && years <= 102) {
            input.parentNode.classList.remove('has-error');
            input.parentNode.classList.add('has-success');
            return true;
        } else {
            input.parentNode.classList.add('has-error');
            input.parentNode.classList.remove('has-success');
            input.nextElementSibling.textContent = "Некорректное значение" + " " + "'" + input.parentNode.childNodes[1].textContent + "'";
            return false;
        }
    } else {
        return true;
    }
};

const validBirthDaySameWithInn = () => {
    var date = getBirthDayFromInn(inn.value);
    var y = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var m = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    var d = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);

    if (birthday.value !== (d + '.' + m + '.' + y)){
      birthday.parentNode.classList.add('has-error');
      birthday.parentNode.classList.remove('has-success');
      birthday.parentNode.querySelector('.help-block').textContent = "Замечено не соответствие ИНН и даты рождения. Проверьте правильность заполнения этих полей.";
      return false;
    }
    birthday.parentNode.classList.remove('has-error');
    birthday.parentNode.classList.add('has-success');
    return true;
};
const validSexSameWithInn = () => {

    if(getSexUUIDFromInn(inn.value) !== sex.value){
      sex.parentNode.parentNode.classList.add('has-error');
      sex.parentNode.parentNode.classList.remove('has-success');
      sex.parentNode.parentNode.querySelector('.help-block').textContent = "Замечено не соответствие ИНН и пола. Проверьте правильность заполнения этих полей.";
      return false;
    }
    sex.parentNode.parentNode.classList.remove('has-error');
    sex.parentNode.parentNode.classList.add('has-success');
    return true;
};

const validTelNumber = (value) => {
    if (value.value.match('_') || value.value == '') {
        value.parentNode.classList.add('has-error');
        value.parentNode.classList.remove('has-success');
        value.parentNode.querySelector('.help-block').textContent = "Некорректное значение" + " " + "'" + value.parentNode.childNodes[1].textContent + "'";
        return false;
    }
    else {
        value.parentNode.classList.remove('has-error');
        value.parentNode.classList.add('has-success');
        return true;
    }
};

const submitFirst = (e) => {
    e.preventDefault();
    $(".titling").slideUp();
    if (validateSum())
    {
        let termInput = document.querySelectorAll('#no-deposit-term')[0];
        creditsWdForm.classList.add('creditsWithoutDeposit-opened');
        creditsWdMain.classList.add('creditsWithoutDeposit-closed');
        creditsWdFormSum.textContent = " " + creditsWdInput.value;
        termInput.value = parseInt(creditsWdFormTerm.textContent);
        // creditsWdFormSubmitButton.setAttribute('disabled', 'enabled');
        validationCreditsForm();
    }
}

const changeDataSubmit = (e) => {
    e.preventDefault();
    $(".titling").show();
    creditsWdForm.classList.remove('creditsWithoutDeposit-opened');
    creditsWdMain.classList.remove('creditsWithoutDeposit-closed');
}

const errorDataMessage = () => {
  creditsWdMain.classList.add('creditsWithoutDeposit-closed');
  creditsWdForm.classList.add('creditsWithoutDeposit-closed');
  creditsWdSuccess.classList.add('creditsWithoutDeposit-opened');

    let successMessage = document.querySelectorAll('.creditsWithoutDeposit-success-row-message')[0];
    let errorMessage = document.querySelectorAll('.creditsWithoutDeposit-error-row-message')[0];
    successMessage.classList.add('creditsWithoutDeposit-success-row-message-closed');
    errorMessage.classList.add('creditsWithoutDeposit-error-row-message-opened');
}

const successDataMessage = () => {
    creditsWdMain.classList.add('creditsWithoutDeposit-closed');
    creditsWdForm.classList.add('creditsWithoutDeposit-closed');
    creditsWdVerification.classList.add('creditsWithoutDeposit-closed');
  creditsWdSuccess.classList.add('creditsWithoutDeposit-opened');

  let successMessage = document.querySelectorAll('.creditsWithoutDeposit-success-row-message')[0];
  let errorMessage = document.querySelectorAll('.creditsWithoutDeposit-error-row-message')[0];
  successMessage.classList.add('creditsWithoutDeposit-success-row-message-opened');
  errorMessage.classList.add('creditsWithoutDeposit-error-row-message-closed');
}

function frontendValidation() {
    let valid = true;
    valid = validName(name) && valid;
    valid = validName(fatherName) && valid;
    valid = validMail(mail) && valid;
    valid = validDateOfBirth(inn.value, inn) && valid;
    valid = validBirthDaySameWithInn() && valid;
    valid = validSexSameWithInn() && valid;
    valid = validTelNumber(tel) && valid;
    valid = validCheckbox() && valid;
    valid = validName(surName) && valid;
    return valid;
}

const gatherFormData = () => {
  let search = window.location.search.substr(1);
  let allowed = [
    "channel",
    "utm_source",
    "instrument",
    "utm_medium",
    "subchannel",
    "utm_campaign",
    "externalid",
    "utm_content",
    "utm_term",
    "pid",
    "cid",
    "adid",
    "an",
    "c",
    "d",
    "dl",
    "dua",
    "geo",
    "ip",
    "num",
    "oid",
    "on",
    "r",
    "src",
    "sub1",
    "sub2",
    "sub3",
    "sub4",
    "sub5",
    "sub6",
    "sub7",
    "sub8",
    "t",
    "tp",
  ];
  let inputsData = {
    first_name: "",
    inn: "",
    email: "",
    last_name: "",
    middle_name: "",
    mobile_phone: "",
    prevcity: "blago",
    credit_sum: "",
    aggreements_check: 1,
    credit_term: "",
    passport_sn: "",
    channel: utm.utm_source,
    utm_source: utm.utm_source,
    instrument: utm.utm_medium,
    utm_medium: utm.utm_medium,
    subchannel: utm.utm_campaign,
    utm_campaign: utm.utm_campaign,
    externalid: utm.externalId,
    utm_content: utm.utm_content,
    utm_term: utm.utm_term,
    pid: utm.pid,
    cid: utm.cid,
    adid: utm.adid,
    an: utm.an,
    c: utm.c,
    d: utm.d,
    dl: utm.dl,
    dua: utm.dua,
    geo: utm.geo,
    ip: utm.ip,
    num: utm.num,
    oid: utm.oid,
    on: utm.on,
    r: utm.r,
    src: utm.src,
    sub1: utm.sub1,
    sub2: utm.sub2,
    sub3: utm.sub3,
    sub4: utm.sub4,
    sub5: utm.sub5,
    sub6: utm.sub6,
    sub7: utm.sub7,
    sub8: utm.sub8,
    t: utm.t,
    tp: utm.tp,
  };

  search.split('&').forEach(function (item) {
    item = item.split('=');

    if (inArray(item[0], allowed)) {
      inputsData[item[0]] = item[1];
    }
  });

  inputsData.sex = sex.value;
  inputsData.birthday = birthday.value;
  inputsData.email = mail.value;
  inputsData.first_name = document.querySelectorAll('#creditapplicationform-first_name')[0].value;
  inputsData.inn = document.querySelectorAll('#creditapplicationform-inn')[0].value;
  inputsData.last_name = document.querySelectorAll('#creditapplicationform-last_name')[0].value;
  inputsData.middle_name = document.querySelectorAll('#creditapplicationform-middle_name')[0].value;
  inputsData.mobile_phone = document.querySelectorAll('#tel')[0].value.replace('(', "").replace(')', "").replace(" ", "").replace("-", "");
  inputsData.credit_sum = Number(creditSumInput.value);
  inputsData.credit_term = Number(document.querySelectorAll('#no-deposit-term')[0].value);
  inputsData.passport_sn = document.querySelectorAll('#passport_sn')[0].value;
  inputsData.mobile_phone.replace('(', "");
  return inputsData;
}

const backendValidation = (success_callback, error_callback) => {
  let button = $('.creditsWithoutDeposit-form-submit-button').find('#dataconfirm');
  $.ajax({
    type: "POST",
    url: "/api/credit/validate",
    data: {CreditApplicationForm: gatherFormData(), _csrf:yii.getCsrfToken() },
    success: function (data) {
      if(Array.isArray(data) && !data.length){
        if(typeof success_callback === 'function'){
          success_callback();
        }
      }else{
        for(let i in data){
          let field = document.querySelector('.field-creditapplicationform-' + i);

          let helpblock = field.querySelector('.help-block');
          let input = field.querySelector('input');
          if(!input){
            input = field.querySelector('select');
          }
          field.classList.add('has-error');
          field.classList.remove('has-success');
          helpblock.textContent = data[i][0];
          input.addEventListener('blur', () => {
            helpblock.textContent = '';
            field.classList.remove('has-error');
            field.classList.add('has-success');
          }, {once: true});
        }
        if(typeof error_callback === 'function') {
          error_callback();
        }
      }
      button.removeClass('disabled-submit-btn');
    },
    error: function () {
      errorDataMessage();
      if(typeof error_callback === 'function') {
        error_callback();
      }
      button.removeClass('disabled-submit-btn');
    },
  });
}

const validateFormAndProcessToNextStep = (e) => {
  if (e){
    e.preventDefault();
  }
  let button = $('.creditsWithoutDeposit-form-submit-button').find('#dataconfirm');
  if (
    !button.hasClass('disabled-submit-btn')
    && frontendValidation()
  ) {
    backendValidation(function(){
      creditsWdVerification.classList.add('creditsWithoutDeposit-opened');
      creditsWdForm.classList.add('creditsWithoutDeposit-closed');
      addGTMLayer('Sms_Code_Sent');
      initCountdown(60);
    });
  }
}

const validateMobileAndProcessToNextStep = (e) => {
  e.preventDefault();
  let verificationInputVal = $('#verification-number').val().toString();
  let phone = gatherFormData()['mobile_phone'];
  if (verificationInputVal.length > 0) {
    $.ajax({
      type: "POST",
      url: "/api/credit/validate-sms-code",
      data: {_csrf:yii.getCsrfToken(), code: verificationInputVal, phone:phone},
      success: function (data) {
        if(Array.isArray(data) && !data.length) {
          addGTMLayer('Sms_Success');
          sendInputsData();
          successDataMessage();
        }else{
          let field = document.querySelector('.creditsWithoutDeposit-verification-row');
          let helpblock = field.querySelector('.help-block');
          let input = field.querySelector('input');
          if(!input){
            input = field.querySelector('select');
          }
          field.classList.add('has-error');
          field.classList.remove('has-success');
          helpblock.textContent = data['error'];
          input.addEventListener('blur', () => {
            helpblock.textContent = '';
            field.classList.remove('has-error');
            field.classList.add('has-success');
          }, {once: true});
        }
      },
      error: function () {
        cancelWaiting();
      },
    })
  }

};


const sendInputsData = () => {
    let button = $('.creditsWithoutDeposit-form-submit-button').find('#dataconfirm');

    if (
      !button.hasClass('disabled-submit-btn')
      && frontendValidation()
    ) {

      button.addClass('disabled-submit-btn');

      $.ajax({
        type: "POST",
        url: "/api/credit",
        data: {CreditApplicationForm: gatherFormData(), _csrf:yii.getCsrfToken() },
        success: function (data) {

          if (data) {
            successDataMessage();
          } else {
            errorDataMessage();
          }
          button.removeClass('disabled-submit-btn');
        },
        error: function () {

          errorDataMessage();
          button.removeClass('disabled-submit-btn');
        },
      });

    }
};


const verificationSybmit = () => {
    creditsWdMain.classList.add('creditsWithoutDeposit-closed');
    creditsWdForm.classList.add('creditsWithoutDeposit-closed');
    creditsWdVerification.classList.add('creditsWithoutDeposit-closed');
    creditsWdSuccess.classList.add('creditsWithoutDeposit-opened');
};


creditsWdSubmitFirst.addEventListener('click', submitFirst);
changeBtn.addEventListener('click', changeDataSubmit);


creditsWdFormSubmitButton.addEventListener('click', validateFormAndProcessToNextStep);
creditsWdVerificationButton.addEventListener('click', validateMobileAndProcessToNextStep);

creditsRulesLink.addEventListener('click', (e) => {
  console.log(creditsRulesLink);

  e.preventDefault();
    openPopup(creditsPopup);
});
credistPopupClose.addEventListener('click', () => {
  console.log(credistPopupClose);
    closePopup(creditsPopup);
});
$('#repeated-client').change(function () {
    if ($(this).is(":checked")) {
        $('#regular-client').prop('checked', false);
        $('#pensioner-client').prop('checked', false);
    }
    updateClientType();
});
$('#pensioner-client').change(function () {
    if ($(this).is(":checked")) {
        $('#regular-client').prop('checked', false);
    }
    updateClientType();
});
$('#regular-client').change(function () {
    if ($(this).is(":checked")) {
        $('#pensioner-client').prop('checked', false);
    }
    updateClientType();
});

function updateClientType() {
    if (!$('#regular-client').is(":checked") && !$('#pensioner-client').is(":checked") && !$('#repeated-client').is(":checked")) {
        updateClient('new_client');
    }
    if (!$('#regular-client').is(":checked") && !$('#pensioner-client').is(":checked") && $('#repeated-client').is(":checked")) {
        updateClient('repeated_client');
    }
    if (!$('#regular-client').is(":checked") && $('#pensioner-client').is(":checked") && $('#repeated-client').is(":checked")) {
        updateClient('pensioner_client');
    }
    if ($('#regular-client').is(":checked") && !$('#pensioner-client').is(":checked") && $('#repeated-client').is(":checked")) {
        updateClient('regular_client');
    }
}
if (Number($('#sum').val()))
{
    if ($('#sum').val() > 5000)
    {
        updateClient('regular_client');
        $('.creditsWithoutDeposit-form-checkbox-hidden').toggleClass('active');
        $('#repeated-client').prop('checked', true);
        $('#regular-client').prop('checked', true);
    } else if ($('#sum').val() <= 5000 && Number($('#period').val()) === 3)
    {
        updateClient('repeated_client');
        $('.creditsWithoutDeposit-form-checkbox-hidden').toggleClass('active');
        $('#repeated-client').prop('checked', true);
    } else if ($('#sum').val() <= 5000)
    {
        updateClient('new_client');
    }
} else {
    updateClient('new_client');
}
$('#repeated-client').on('click', function() {
    $('.creditsWithoutDeposit-form-checkbox-hidden').toggleClass('active');
});

function inArray(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
    if (haystack[i] == needle)
      return true;
  }
  return false;
}

function initCountdown (seconds){
  --seconds;
  let parent = document.querySelector('.resend-countdown');
  let secondsSpan = document.querySelector('.resend-countdown .countdown .seconds');
  secondsSpan.textContent = ("0" + seconds).slice(-2);
  if (seconds > 0){
    parent.classList.add("disabled");
    setTimeout(initCountdown, 1000, seconds);
  }else{
    setTimeout(() => {
      parent.classList.remove("disabled");
    }, 1000, seconds);
  }
}

function getBirthDayFromInn(inn) {
  var days = ('' + inn).substring(0,5)
  var D = new Date(1899,11,31);
  D.setDate(D.getDate() + +days);
  return D;
}
function getSexUUIDFromInn(inn) {
  var sexUUIDs = [
    'FC2483F8-65B6-DF11-831A-001D60E938C6',
    'EEAC42EE-65B6-DF11-831A-001D60E938C6'
  ];
  return sexUUIDs[+(('' + inn).substring(8,9)) % 2];
}

$('.resend-countdown').on('click', function (e) {
  let elm = $(e.currentTarget);
  if (!elm.hasClass('disabled')) {
    validateFormAndProcessToNextStep();
  }
});

